import Badge from './src/main';

module.exports = Badge;


// WEBPACK FOOTER //
// ./src/components/badge/index.js